import React from "react";
import { QuestionsIcon } from "../../Icons/IconPackage/Message";
import "./style.scss";

const ButtonQuestionWriteForm = ({settings = null, title, onClick}) => {
    return (
        <button
            className={`question-message-write-button ${(!!settings && settings?.askQuestionAccentStyle) ? 'question-message-write-button--accent' : ''}`}
            onClick={onClick}
        >
            <QuestionsIcon />
            <span>{title}</span>
        </button>
    );
}

export default ButtonQuestionWriteForm;
